import { useCallback, useEffect, useMemo, useState } from 'react';
import { Option, OptionKey, usePaginationParams } from '@common-fe/common-fe';
import _ from 'lodash';

import { ALL_OPTION } from '@/common/constants';

import { ResendItemStatus, ResendItemStatusTitlesMap, ResendItemType } from '../ResendSection.types';

const useSearchParams = () => {
  const [statuses, setStatuses] = useState<OptionKey[]>([ALL_OPTION.value]);
  const [period, setPeriod] = useState<[Date | null, Date | null]>([null, null]);
  const [currentTypes, setCurrentTypes] = useState<OptionKey[]>([ALL_OPTION.value]);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(10);
  const statusOptions = useMemo(() => {
    const keysList = [
      ResendItemStatus.Sent,
      ResendItemStatus.NotSent,
      ResendItemStatus.Resent,
      ResendItemStatus.Sending,
      ResendItemStatus.Bounced,
      ResendItemStatus.Delivered,
      ResendItemStatus.Opened,
      ResendItemStatus.ReportedAsSpam,
      ResendItemStatus.Unsubscribed,
    ];
    const list: Option[] = [
      ALL_OPTION,
      ...keysList.map((key) => {
        const item: Option = {
          key: key,
          title: ResendItemStatusTitlesMap[key],
        };
        return item;
      }),
    ];

    return list;
  }, []);

  const typeOptions = useMemo(() => {
    const list: Option[] = [
      ALL_OPTION,
      {
        key: ResendItemType.Email,
        title: 'Email',
      },
      {
        key: ResendItemType.Letter,
        title: 'Letter',
      },
      {
        key: ResendItemType.SMS,
        title: 'SMS/Text',
      },
    ];
    return list;
  }, []);
  useEffect(() => {
    setPage(0);
  }, [statuses, period, currentTypes, setPage]);
  const handleSetCurrentTypes = useCallback((options: OptionKey[]) => {
    const last = _.last(options);
    if (last === ALL_OPTION.key) {
      setCurrentTypes([ALL_OPTION.key]);
    } else {
      setCurrentTypes(options.filter((item) => item !== ALL_OPTION.key));
    }
  }, []);

  const handleSetStatus = useCallback((options: OptionKey[]) => {
    const last = _.last(options);
    if (last === ALL_OPTION.key) {
      setStatuses([ALL_OPTION.key]);
    } else {
      setStatuses(options.filter((item) => item !== ALL_OPTION.key));
    }
  }, []);

  return {
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    setSearchString,
    currentSearch,

    statuses,
    setStatuses: handleSetStatus,
    statusOptions,

    currentTypes,
    setCurrentTypes: handleSetCurrentTypes,
    typeOptions,

    period,
    setPeriod,
  };
};

export default useSearchParams;
